var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0.226318C10.7625 0.226318 0 10.9888 0 24.2263C0 37.4638 10.7625 48.2263 24 48.2263C37.2375 48.2263 48 37.4638 48 24.2263C48 10.9888 37.2375 0.226318 24 0.226318Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0092 10.1638C23.7373 10.1638 23.4842 10.2857 23.3155 10.5013L13.7905 22.7263C13.5842 22.9888 13.5467 23.3544 13.6967 23.6544C13.8373 23.9544 14.1561 24.1513 14.4842 24.1513H20.7467V37.4169C20.7467 37.9044 21.1405 38.2982 21.628 38.2982H26.3717C26.8592 38.2982 27.253 37.9044 27.253 37.4169V24.1419H33.5155C33.853 24.1419 34.1623 23.9544 34.303 23.6451C34.453 23.3451 34.4155 22.9888 34.1998 22.7169L24.6936 10.5013C24.5342 10.2951 24.2717 10.1638 24.0092 10.1638Z",
    fill: "#F7A294"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.046f6c543f6d3469c32debc7d805ccaa.svg";
export { ForwardRef as ReactComponent };